<script setup>
import App from '@/Layouts/App.vue';
</script>

<template>
  <App>
    <div class="container prose py-8">
      <h1>{{ $page.props.h1 }}</h1>
      <div>{{ $t('Effective Date') }}: {{ $page.props.updated_at }}</div>

      <div v-html="$page.props.intro" />
    </div>
  </App>
</template>

<style scoped></style>
